import { Button, Dropdown, Menu, Checkbox } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './styles.scss';

const ALL = -2;

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const uniq = (arr) => Array.from(new Set(arr));

const AllocationModalDropdownCheckbox = ({
  allocation,
  setAllocation,
  label,
  type,
  checkedScenarios,
  items = [],
  onConcreteScenarioPicked,
}) => {
  const itemIds = items
    .map((i) => toNum(i.id))
    .filter((n) => n != null);

  const allowedSet = new Set(itemIds);

  const current = Array.isArray(checkedScenarios)
    ? checkedScenarios.map(toNum).filter((n) => n != null && n !== ALL)
    : [];

  const isAllSelected =
    Array.isArray(allocation?.[type]) &&
    allocation[type].map(toNum).includes(ALL);

  const setField = (nextArr) => {
    setAllocation((prev) => ({ ...prev, [type]: uniq(nextArr) }));
  };

  const onClickAll = () => {
    setField([ALL]);
  };

  const onChangeCheckbox = (itemId) => {
    const id = toNum(itemId);
    if (id == null) return;

    const wasConcreteSelection =
      Array.isArray(allocation?.[type]) &&
      !allocation[type].map(toNum).includes(ALL);

    setAllocation((prev) => {
      const raw = Array.isArray(prev?.[type]) ? prev[type] : [];
      const hadAll = raw.map(toNum).includes(ALL);

      const currentConcrete = raw
        .map(toNum)
        .filter((n) => n != null && n !== ALL);

      let next;
      if (hadAll) {
        next = [id];
      } else if (currentConcrete.includes(id)) {
        next = currentConcrete.filter((x) => x !== id);
      } else {
        next = [...currentConcrete, id];
      }

      const concrete = uniq(next).filter((x) => allowedSet.has(x));

      return {
        ...prev,
        [type]: concrete.length === 0 ? [] : concrete,
      };
    });

    // only auto-select entity when a concrete scenario is being picked
    if (isAllSelected || !wasConcreteSelection || !current.includes(id)) {
      onConcreteScenarioPicked?.(id);
    }
  };

  const AllocationModalDropdownMenuItem = (item, idx) => {
    const id = toNum(item?.id);
    const name = item?.name ?? '—';
    const key = id != null ? String(id) : `tmp-${idx}`;
    const isChecked = isAllSelected || (id != null && current.includes(id));

    return (
      <Menu.Item
        key={key}
        onClick={(e) => {
          e.domEvent?.stopPropagation?.();
        }}
      >
        {name}
        <Checkbox
          checked={isChecked}
          onChange={() => id != null && onChangeCheckbox(id)}
          style={{ float: 'right' }}
          onClick={(e) => e.stopPropagation()}
        />
      </Menu.Item>
    );
  };

  const menu = (
    <Menu style={{ maxHeight: '250px', overflow: 'auto' }}>
      <Menu.Item onClick={onClickAll} key="ALL">
        All
      </Menu.Item>
      {items.map((item, idx) => AllocationModalDropdownMenuItem(item, idx))}
    </Menu>
  );

  const findAllocationItemLabel = () => {
    const sel = Array.isArray(allocation?.[type]) ? allocation[type] : [];
    const nums = sel.map(toNum).filter((n) => n != null);

    if (nums.includes(ALL)) return 'All';
    if (nums.length === 0) return 'None';
    if (nums.length === 1) {
      const one = items.find((i) => Number(i.id) === nums[0]);
      return one ? one.name : '1 selected';
    }
    return `${nums.length} selected`;
  };

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button style={{ minWidth: '224px', minHeight: '38px', textAlign: 'center' }}>
        {findAllocationItemLabel() || label}
        <DownOutlined style={{ position: 'absolute', right: '15px', paddingTop: '7.5px' }} />
      </Button>
    </Dropdown>
  );
};

export default AllocationModalDropdownCheckbox;